import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import { DatePicker } from 'material-ui-pickers';
import { TimePicker } from 'material-ui-pickers';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';
import { AddButton, DeleteButton } from 'components/core';
import {
  ClientDialog,
  CrewDialog,
  WorkTypeDialog,
 } from 'components/admin/Dialogs';
import { startRemoveTimecardField } from 'store/actions/timecards';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  avatar: {
  },
  cardContent: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: theme.spacing.unit*2,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    padding: theme.spacing.unit*2,
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing.unit*2,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    padding: theme.spacing.unit*2,
  },
  field: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    width: '200px',
  },
  typography: {
    marginTop: theme.spacing.unit*2,
  },
  textRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: theme.spacing.unit,
  },
  notes: {
    marginTop: theme.spacing.unit,
    padding: theme.spacing.unit*2,
  },
  clientControl: {
    width: '200px',
    margin: '0px',
    marginRight: theme.spacing.unit*2,
  },
});

//TODO: move this into timecard as a property
const minutesWorked = (timecard) => {
  return moment(timecard.endDate).diff(moment(timecard.startDate), "minutes");
}


class Detail extends Component {
  constructor(props){
    super(props);
    this.state = {
      showAddClient: false,
      showAddCrew: false,
      showAddWorkType: false,
    };
  }

  chargedToClient() {
    const { timecard, workType } = this.props;

    if (workType && timecard) {
      const worked = (minutesWorked(timecard)/60).toFixed(1);
      const rate = Number(workType.rate).toFixed(2);
      return (worked*rate).toFixed(2);
    } else {
      return 0;
    }
  }

  render() {
    const {
      classes,
      timecard,
      crew,
      clients,
      projects,
      showValidation,
      validation,
      workTypes,
      workType,
      handleChange,
    } = this.props;
    const {
      showAddClient,
      showAddCrew,
      showAddWorkType,
    } = this.state;

    return(
      <div className={classes.root}>
        <ClientDialog
          show={showAddClient}
          handleCreated={(result) => {
            handleChange("clientId", result);
          }}
          handleClose={() => this.setState({ showAddClient: false })}
        />
        <CrewDialog
          show={showAddCrew}
          handleCreated={(result) => {
            handleChange("crewId", result);
          }}
          handleClose={() => this.setState({ showAddCrew: false })}
        />
        <WorkTypeDialog
          show={showAddWorkType}
          handleCreated={(result) => {
            handleChange("workTypeId", result);
          }}
          handleClose={() => this.setState({ showAddWorkType: false })}
        />
        <div className={classes.row}>
          <Card className={classes.leftColumn}>
            <CardHeader
              title="Time"
            />
            <CardContent className={classes.cardContent}>
              <Tooltip type={TooltipTypes.TIMECARD_CHANGE_TIME} placement="left">
                <DatePicker
                    className={classes.field}
                    label="Date"
                    format="MMMM Do YYYY"
                    value={timecard.startDate}
                    leftArrowIcon={<ArrowBackIcon />}
                    rightArrowIcon={<ArrowForwardIcon />}
                    onChange={(date) => {
                      handleChange("startDate", date.toDate().getTime());
                      helpDispatch();
                    }}
                />
              </Tooltip>
              <TimePicker
                className={classes.field}
                keyboard
                label="Time Started"
                mask={[/\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, 'M']}
                placeholder="08:00 AM"
                value={timecard.startDate}
                onChange={(date) => handleChange("startTime", date.toDate().getTime())}
              />
              <TimePicker
                className={classes.field}
                keyboard
                label="Time Ended"
                mask={[/\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, 'M']}
                placeholder="08:00 AM"
                value={timecard.endDate}
                onChange={(date) => handleChange("endTime", date.toDate().getTime())}
              />
              <div className={classes.row}>
                <FormControl className={classes.clientControl}>
                  <InputLabel htmlFor="crew-simple">Crew</InputLabel>
                  <Select
                    value={timecard.crewId === undefined ? "" : timecard.crewId}
                    onChange={(event) => {
                      handleChange("crewId", event.target.value);
                    }}
                    inputProps={{
                      name: 'crewId',
                      id: 'crew-simple',
                    }}
                  >
                    {crew &&
                      crew.map((crew, i) => {
                        return <MenuItem key={i} value={crew.id}>{crew.crewFirstName}</MenuItem>
                      })
                    }
                  </Select>
                  {showValidation && validation.validateField("crewId") &&
                    <FormHelperText>{validation.validateField("crewId")}</FormHelperText>
                  }
                </FormControl>
                <Tooltip type={TooltipTypes.TIMECARD_CREATE_CREW} placement="right">
                  <AddButton
                    onClick={() => {
                      this.setState({ showAddCrew: true });
                      helpDispatch();
                    }}
                  />
                </Tooltip>
              </div>
            </CardContent>
          </Card>
          <Card className={classes.rightColumn}>
            <CardHeader
              title="Invoicing"
            />
            <CardContent className={classes.cardContent}>
              <div className={classes.row}>
                <FormControl className={classes.clientControl}>
                  <InputLabel htmlFor="client-simple">Client</InputLabel>
                  <Select
                    value={timecard.clientId === undefined ? "" : timecard.clientId}
                    onChange={(event) => {
                      handleChange("clientId", event.target.value);
                    }}
                    inputProps={{
                      name: 'clientId',
                      id: 'client-simple',
                    }}
                  >
                    {clients &&
                      clients.map((client, i) => {
                        return <MenuItem key={i} value={client.id}>{`${client.lastName}, ${client.firstName}`}</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <Tooltip type={TooltipTypes.TIMECARD_CREATE_CLIENT} placement="bottom">
                  <AddButton
                    onClick={() => {
                      this.setState({ showAddClient: true });
                      helpDispatch();
                    }}
                  />
                </Tooltip>
              </div>
              <div className={classes.row}>
                <FormControl className={classes.clientControl}>
                  <InputLabel htmlFor="job-simple">Job (optional)</InputLabel>
                  <Select
                    value={timecard.projectId === undefined ? "" : timecard.projectId}
                    onChange={(event) => {
                      handleChange("projectId", event.target.value);
                    }}
                    inputProps={{
                      name: 'jobId',
                      id: 'job-simple',
                    }}
                  >
                    {projects &&
                      projects.map((project, i) => {
                        return <MenuItem key={i} value={project.id}>{project.jobCode}</MenuItem>
                      })
                    }
                  </Select>
                </FormControl>
                <DeleteButton
                  onClick={() => handleChange("projectId", null)}
                />
              </div>
              <div className={classes.row}>
                <Tooltip type={TooltipTypes.timecard.WORKTYPES} placement="left">
                  <div />
                </Tooltip>
                <Tooltip type={TooltipTypes.TIMECARD_SELECT_WORKTYPE} placement="right">
                  <FormControl className={classes.clientControl}>
                    <InputLabel htmlFor="worktypes-simple">Work Type</InputLabel>
                    <Select
                      value={timecard.workTypeId === undefined ? "" : timecard.workTypeId}
                      onChange={(event) => {
                        handleChange("workTypeId", event.target.value);
                        helpDispatch();
                      }}
                      inputProps={{
                        name: 'workTypeId',
                        id: 'worktypes-simple',
                      }}
                    >
                      {workTypes &&
                        workTypes.map((workType, i) => {
                          return <MenuItem key={i} value={workType.id}>{workType.name}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </Tooltip>
                <AddButton
                  onClick={() => this.setState({ showAddWorkType: true })}
                />
              </div>
              <div className={classes.textRow}>
                <Typography
                  variant="subheading">
                  Hours Worked:
                </Typography>
                <Tooltip type={TooltipTypes.TIMECARD_CHARGES} placement="top">
                  <Typography
                    variant="subheading">
                    {(minutesWorked(timecard)/60).toFixed(1)}
                  </Typography>
                </Tooltip>
              </div>
              <div className={classes.textRow}>
                <Typography
                  variant="subheading">
                  Rate:
                </Typography>
                <Typography
                  variant="subheading">
                  {`$${workType === undefined ? 0 : Number(workType.rate).toFixed(2)}`}
                </Typography>
              </div>
              <Divider />
              <div className={classes.textRow}>
                <Typography
                  className={classes.typographySM}
                  variant="subheading">
                  Charged to Client:
                </Typography>
                <Typography
                  className={classes.typographySM}
                  variant="subheading">
                  {`$${this.chargedToClient()}`}
                </Typography>
              </div>

              <Tooltip type={TooltipTypes.TIMECARD_BILL_TO} placement="left">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={timecard.billToClient === undefined ? false : timecard.billToClient}
                      onChange={(event) => {
                        handleChange("billToClient", !timecard.billToClient);
                        helpDispatch();
                      }}
                      color="primary"
                    />
                  }
                  label="Bill to Client/Job"
                />
              </Tooltip>
            </CardContent>
          </Card>
        </div>
        <Card className={classes.notes}>
          <Tooltip type={TooltipTypes.TIMECARD_NOTES} placement="left">
            <TextField
              margin="dense"
              id="name"
              label="Notes (optional)"
              fullWidth
              multiline={true}
              value={timecard.notes}
              onChange={(event) => handleChange("notes", event.target.value)}
            />
          </Tooltip>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { timecard } = props;
  const clients = state.clientsState;
  const crew = state.crewState;

  const workTypes = state.workTypesState;
  const client = clients.find(client => client.id === timecard.clientId);
  const projects = client && state.projectsState.filter(project => client.id === project.clientId);
  let workType;
  if (timecard !== undefined && timecard.workTypeId !== undefined) {
    workType = workTypes.find(workType => workType.id === timecard.workTypeId);
  }

  return {
    crew: crew,
    clients: clients,
    projects: projects,
    workTypes: workTypes,
    workType: workType,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Detail);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/Dialog/Detail.jsx